var map = {
	"./NVR.png": "e500",
	"./NVR_failed.png": "0a3a",
	"./NVR_normal.png": "2e64",
	"./NVR_unknown.png": "afb8",
	"./NVR_w.png": "afcc",
	"./board.png": "547c",
	"./board_w.png": "5d58",
	"./camera.png": "6cff",
	"./camera1.png": "380a",
	"./camera_failed.png": "30d5",
	"./camera_normal.png": "b2c3",
	"./camera_unknown.png": "aca7",
	"./camera_w.png": "9281",
	"./center.png": "86ca",
	"./center_failed.png": "c386",
	"./center_normal.png": "b028",
	"./center_unknown.png": "9d89",
	"./center_w.png": "f1dd",
	"./cityStore_failed.png": "3623",
	"./cityStore_normal.png": "ede2",
	"./cityStore_unknown.png": "e791",
	"./city_failed.png": "d281",
	"./city_normal.png": "5c01",
	"./city_unknown.png": "5a211",
	"./collector.png": "da87",
	"./collector_failed.png": "47e5",
	"./collector_normal.png": "7b2b",
	"./collector_unknown.png": "201f",
	"./collector_w.png": "aaa1",
	"./meter.png": "404a",
	"./meter_failed.png": "1cfd",
	"./meter_normal.png": "a54a",
	"./meter_unknown.png": "54a2",
	"./meter_w.png": "8b3b",
	"./platform.png": "67b9",
	"./platform_failed.png": "111a",
	"./platform_normal.png": "5da3",
	"./platform_unknown.png": "a6af",
	"./platform_w.png": "1828",
	"./province_failed.png": "f85c",
	"./province_normal.png": "5a21b",
	"./province_unknown.png": "388c",
	"./queue_failed.png": "35af",
	"./queue_normal.png": "e490",
	"./queue_unknown.png": "feda",
	"./site.png": "77ad",
	"./site_failed.png": "9839",
	"./site_normal.png": "22d6",
	"./site_unknown.png": "33a1",
	"./site_w.png": "7e25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a7a";